/* tslint:disable */
/* eslint-disable */
/**
 * Animare Secrets API
 * This API allows to decrypt secrets and hash strings for admin purposes.
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DecryptionDto
 */
export interface DecryptionDto {
  /**
   * Code of the type of secret that should be used to decrypt the ciphertext.
   * @type {string}
   * @memberof DecryptionDto
   */
  secretTypeCode?: string
  /**
   * Ciphertext to be decrypted.
   * @type {string}
   * @memberof DecryptionDto
   */
  ciphertext?: string
  /**
   * Plaintext after decryption.
   * @type {string}
   * @memberof DecryptionDto
   */
  plaintext?: string
}

/**
 * Check if a given object implements the DecryptionDto interface.
 */
export function instanceOfDecryptionDto(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function DecryptionDtoFromJSON(json: any): DecryptionDto {
  return DecryptionDtoFromJSONTyped(json, false)
}

export function DecryptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DecryptionDto {
  if (json === undefined || json === null) {
    return json
  }
  return {
    secretTypeCode: !exists(json, 'secretTypeCode') ? undefined : json['secretTypeCode'],
    ciphertext: !exists(json, 'ciphertext') ? undefined : json['ciphertext'],
    plaintext: !exists(json, 'plaintext') ? undefined : json['plaintext'],
  }
}

export function DecryptionDtoToJSON(value?: DecryptionDto | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    secretTypeCode: value.secretTypeCode,
    ciphertext: value.ciphertext,
    plaintext: value.plaintext,
  }
}
